import { GenericDataApi } from '@/lib/data/GenericDataApi';
import { MaterialDestination } from '@/models/api/Data/material-destination';
import AppHttp from '@/lib/AppHttp';
import { TaskCategory } from '@/models/api';

export class TaskCategories extends GenericDataApi<TaskCategory> {
    constructor() {
        super('TaskCategories');
    }

    public async getForMineArea(mineAreaId: string, include?: string[]): Promise<TaskCategory[]> {
        let query = '';
        if (include) {
            const p: string = include.map((x) => `include=${x}`).join('&');
            query = '?' + p;
        }

        const response = await AppHttp.get(`${this.resource}/MineAreas/${mineAreaId}${query}`);

        const data = response ? response.data : null;
        if(data == null) throw Error('No response data');
        return data;
    }
}

export default new TaskCategories();
